import { useForm } from "react-hook-form";
import { useSaveLocation } from "../../pages/customer-settings/tabs/locations/hooks/useSaveLocation";
import {
  ILocationForm,
  defaultLocationFormVariables,
} from "../../pages/customer-settings/tabs/locations/variables/locationData";
import { useCustomerExternalIdGuard } from "./useCustomerExternalIdGuard";
import { useCustomerIdGuard } from "./useCustomerIdGuard";
import {
  errorNotification,
  successNotification,
} from "../variables/notification";

export const useLocationFormHandler = (onSumbitHandler: () => void) => {
  const customerId = useCustomerIdGuard();
  const externalCustomerId = useCustomerExternalIdGuard();

  const [saveLocationItem, { loading }] = useSaveLocation();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ILocationForm>({
    defaultValues: defaultLocationFormVariables,
  });

  const onSubmit = (data: ILocationForm) => {
    saveLocationItem({
      input: {
        customerId,
        customerExternalId: externalCustomerId,
        id: data.locationName,
        referenceId: data.referenceId,
        name: data.locationName,
        tags: data.tags.map(({ tagName, id }) => ({ tagName, id })),
        locationData: JSON.stringify({
          lat: data.latitude,
          lon: data.longitude,
        }),
        timeZone: data.timeZone,
      },
    })
      .then(response => {
        if (!response.data?.addLocation?.id) return;

        successNotification(`${response.data?.addLocation?.name} is added`);

        onSumbitHandler();
      })
      .catch(error => {
        errorNotification(error.message);

        console.error(error);
      });
  };

  return {
    control,
    handleSubmit: handleSubmit(onSubmit),
    errors,
    reset,
    loading,
  };
};
